import { render, staticRenderFns } from "./aiheader-info.vue?vue&type=template&id=778c9d6a&"
import script from "./aiheader-info.vue?vue&type=script&lang=js&"
export * from "./aiheader-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aiheader-info.vue"
export default component.exports